import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-success-error-actions-renderer',
    template: `
        <div class="flex align-items-center list-user-action">
            <ng-container *ngIf="isCompleted">
                <i class="bx bx-check-circle text-success me-1" title="Success"></i>
            </ng-container>
            <ng-container *ngIf="isValidationError">
                <i class="bx bx-error-circle text-danger me-1" (click)="invokeOpenJobValidationModal()" title="Validation Error"></i>
            </ng-container>
            <ng-container *ngIf="isProcessingError">
                <i class="bx bx-error text-warning me-1" (click)="invokeOpenJobErrorModal()" title="Processing Error"></i>
            </ng-container>
            <ng-container *ngIf="isInProcess">
                <i class="bx bx-loader-alt text-warning me-1 spin-animation" title="In Process"></i>
            </ng-container>
        </div>
    `,
    styles: [
        `
            .list-user-action {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
            }
            .list-user-action i {
                margin-top : 4px;
                font-size: 1.2rem;
                cursor: pointer;
            }
            .spin-animation {
                animation: spin 1s linear infinite;
            }
            @keyframes spin {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
        `,
    ],
})
export class JOBQueueStatusRenderer implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    public isCompleted = false;
    public isValidationError = false;
    public isProcessingError = false;
    public isInProcess = false;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        const status = this.params.value;

        switch (status) {
            case 'RUNNING':
            case 'VALIDATING':
            case 'PROCESSING':
                this.setStatus(true, false, false, false);
                break;
            case 'VALIDATION ERROR':
            case 'VALIDATION COMPLETED WITH ERROR':
                this.setStatus(false, true, false, false);
                break;
            case 'PROCESSING ERROR':
                this.setStatus(false, false, true, false);
                break;
            case 'VALIDATION COMPLETED':
            case 'PROCESSED':
                this.setStatus(false, false, false, true);
                break;
            default:
                console.warn('Unexpected status:', status);
                this.setStatus(false, false, false, false);
        }
    }

    private setStatus(inProcess: boolean, validationError: boolean, processingError: boolean, completed: boolean) {
        this.isInProcess = inProcess;
        this.isValidationError = validationError;
        this.isProcessingError = processingError;
        this.isCompleted = completed;
    }

    public invokeOpenJobValidationModal() {
        this.params.context.componentParent.openJobValidationModal(this.params.node.data);
    }

    public invokeOpenJobErrorModal() {
        this.params.context.componentParent.openJobErrorModal(this.params.node.data);
    }

    refresh(): boolean {
        return false;
    }
}
